import { useCallback } from 'react'
import { trackUserEvent } from '@vend/utilities'
import { useTrainingModeManager } from '../../../ng-compat/hooks'
import { $state } from '../../../ng-compat/imports'
import { STATES } from '../../../../../lib/routes'
import { WEB_REGISTER } from '../../web-register.constant'

export const useCompleteTutorial = () => {
  const trainingModeManager = useTrainingModeManager()

  const completeTutorial = useCallback(async () => {
    const currentTourType = trainingModeManager.currentTourType
    if (trainingModeManager.trainingModeEnabled) {
      await trainingModeManager.exitTrainingMode()
      await $state.go(STATES.SALE, {}, { location: 'replace', notify: true })
      trackUserEvent(
        WEB_REGISTER.APPLICATION_NAME,
        currentTourType || 'Complete training',
        {
          step: 'Completed Tutorial',
          triggeredBy: 'button',
        }
      )
    }
  }, [trainingModeManager])

  return completeTutorial
}
